// Desktop video autoplay via IntersectionObserver
// Only runs on desktop (min-width: 769px) — mobile uses Swiper slideChange
(function () {
  if (window.matchMedia('(max-width: 768px)').matches) return;

  function initObserver() {
    var gallery = document.querySelector('media-gallery-swiper [id^="GalleryViewer"]');
    if (!gallery) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var dm = entry.target;
        if (entry.isIntersecting) {
          if (dm.getAttribute('loaded') !== 'true') {
            dm.loadContent(false);
          } else if (dm.deferredElement) {
            dm.setAttribute('data-state', 'playing');
          }
        } else {
          if (dm.getAttribute('loaded') === 'true' && dm.deferredElement) {
            dm.setAttribute('data-state', 'paused');
          }
        }
      });
    }, { threshold: 0.5 });

    gallery.querySelectorAll('deferred-media').forEach(function (dm) {
      observer.observe(dm);
    });
  }

  // Wait for custom elements to be defined
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
